import { Routes, RouterModule } from '@angular/router';
import { AddBenefitComponent } from './add-benefit.component';

const AddBenefitModule: Routes = [
  {
    path: '',
    component: AddBenefitComponent,
  },
];

export const MAIN_ADDBENEFITS = RouterModule.forChild(AddBenefitModule);
